//# sourceMappingURL=block.mjs.map
/// <reference types="./block.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $timestamp from "../../../gleam_time/gleam/time/timestamp.mjs";
import * as $json_ from "../../../tiamat/gleam/json_.mjs";
import * as $user_id from "../../data/auth/user_id.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import * as $decrypt from "../../decrypt.mjs";
import { toList, CustomType as $CustomType } from "../../gleam.mjs";

export class Block extends $CustomType {
  constructor(element_type, id, owner, content, doc_id_order, metadata, proposal_id, qa_order, ai_processing, updated_at, created_at) {
    super();
    this.element_type = element_type;
    this.id = id;
    this.owner = owner;
    this.content = content;
    this.doc_id_order = doc_id_order;
    this.metadata = metadata;
    this.proposal_id = proposal_id;
    this.qa_order = qa_order;
    this.ai_processing = ai_processing;
    this.updated_at = updated_at;
    this.created_at = created_at;
  }
}
export const Block$Block = (element_type, id, owner, content, doc_id_order, metadata, proposal_id, qa_order, ai_processing, updated_at, created_at) =>
  new Block(element_type,
  id,
  owner,
  content,
  doc_id_order,
  metadata,
  proposal_id,
  qa_order,
  ai_processing,
  updated_at,
  created_at);
export const Block$isBlock = (value) => value instanceof Block;
export const Block$Block$element_type = (value) => value.element_type;
export const Block$Block$0 = (value) => value.element_type;
export const Block$Block$id = (value) => value.id;
export const Block$Block$1 = (value) => value.id;
export const Block$Block$owner = (value) => value.owner;
export const Block$Block$2 = (value) => value.owner;
export const Block$Block$content = (value) => value.content;
export const Block$Block$3 = (value) => value.content;
export const Block$Block$doc_id_order = (value) => value.doc_id_order;
export const Block$Block$4 = (value) => value.doc_id_order;
export const Block$Block$metadata = (value) => value.metadata;
export const Block$Block$5 = (value) => value.metadata;
export const Block$Block$proposal_id = (value) => value.proposal_id;
export const Block$Block$6 = (value) => value.proposal_id;
export const Block$Block$qa_order = (value) => value.qa_order;
export const Block$Block$7 = (value) => value.qa_order;
export const Block$Block$ai_processing = (value) => value.ai_processing;
export const Block$Block$8 = (value) => value.ai_processing;
export const Block$Block$updated_at = (value) => value.updated_at;
export const Block$Block$9 = (value) => value.updated_at;
export const Block$Block$created_at = (value) => value.created_at;
export const Block$Block$10 = (value) => value.created_at;

export class Metadata extends $CustomType {
  constructor(paragraph_id) {
    super();
    this.paragraph_id = paragraph_id;
  }
}
export const Metadata$Metadata = (paragraph_id) => new Metadata(paragraph_id);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$paragraph_id = (value) => value.paragraph_id;
export const Metadata$Metadata$0 = (value) => value.paragraph_id;

function metadata_decoder() {
  return $decrypt.optional_field(
    "paragraph_id",
    $decode.string,
    (paragraph_id) => { return $decode.success(new Metadata(paragraph_id)); },
  );
}

/**
 * Decodes a `Block`. When `lenient` is `True`, decodes any block-like data
 * structure, without ensuring it's not something else. When `lenient` is
 * `False`, decodes only `Block` data.
 */
export function decoder(lenient) {
  return $decode.field(
    "element_type",
    (() => {
      if (lenient) {
        return $kind.decoder();
      } else {
        return $kind.block_decoder();
      }
    })(),
    (element_type) => {
      return $decode.field(
        "id",
        $decode.string,
        (id) => {
          return $decode.field(
            "content",
            $decode.string,
            (content) => {
              return $decode.field(
                "doc_id_order",
                $decode.int,
                (doc_id_order) => {
                  return $decode.field(
                    "metadata",
                    $decrypt.json(metadata_decoder()),
                    (metadata) => {
                      return $decode.field(
                        "proposal_id",
                        $decode.string,
                        (proposal_id) => {
                          return $decode.field(
                            "owner",
                            $decode.optional($user_id.decoder()),
                            (owner) => {
                              return $decode.field(
                                "qa_order",
                                $decode.int,
                                (qa_order) => {
                                  return $decrypt.optional_field(
                                    "ai_processing",
                                    $decode.bool,
                                    (ai_processing) => {
                                      let ai_processing$1 = $option.unwrap(
                                        ai_processing,
                                        false,
                                      );
                                      return $decrypt.optional_field(
                                        "created_at",
                                        $decrypt.timestamp(),
                                        (created_at) => {
                                          let created_at$1 = $option.lazy_unwrap(
                                            created_at,
                                            $timestamp.system_time,
                                          );
                                          return $decrypt.optional_field(
                                            "updated_at",
                                            $decrypt.timestamp(),
                                            (updated_at) => {
                                              let updated_at$1 = $option.lazy_unwrap(
                                                updated_at,
                                                $timestamp.system_time,
                                              );
                                              return $decode.success(
                                                new Block(
                                                  element_type,
                                                  id,
                                                  owner,
                                                  content,
                                                  doc_id_order,
                                                  metadata,
                                                  proposal_id,
                                                  qa_order,
                                                  ai_processing$1,
                                                  updated_at$1,
                                                  created_at$1,
                                                ),
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode_metadata(metadata) {
  return $json.object(
    toList([
      ["paragraph_id", $json.nullable(metadata.paragraph_id, $json.string)],
    ]),
  );
}

export function encode(element) {
  return $json.object(
    toList([
      ["element_type", $json.string($kind.to_string(element.element_type))],
      ["id", $json.string(element.id)],
      ["content", $json.string(element.content)],
      ["doc_id_order", $json.int(element.doc_id_order)],
      ["metadata", encode_metadata(element.metadata)],
      ["proposal_id", $json.string(element.proposal_id)],
      ["owner", $json.nullable(element.owner, $user_id.encode)],
      ["qa_order", $json.int(element.qa_order)],
      ["ai_processing", $json.bool(element.ai_processing)],
      ["updated_at", $json_.to_rfc3339(element.updated_at)],
      ["created_at", $json_.to_rfc3339(element.created_at)],
    ]),
  );
}

export function empty_metadata() {
  return new Metadata(new None());
}

export function empty() {
  return new Block(
    new $kind.Other(),
    "",
    new None(),
    "",
    -1,
    empty_metadata(),
    "",
    -1,
    false,
    $timestamp.system_time(),
    $timestamp.system_time(),
  );
}
